<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>
          {{ 'Assets' | translate }}
        </h1>
        <div class="page__title_buttons">
          <p-button [label]="'Add' | translate" icon="pi pi-plus" (click)="redirectToAssetDetails('new')" />
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterStateConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterStateConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'Assets' | translate">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="assets()" selectionMode="single" (onSort)="onSort($event)" [lazy]="true" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="assetId" style="width: 115px">
                  {{ 'Assets_Table.AssetId' | translate }}
                  <p-sortIcon field="assetId" />
                </th>
                <th>
                  {{ 'Assets_Table.Category' | translate }}
                </th>
                <th>
                  {{ 'Assets_Table.Type' | translate }}
                </th>
                <th>
                  {{ 'Assets_Table.Model' | translate }}
                </th>
                <th style="width: 125px">
                  {{ 'Assets_Table.SiteCode' | translate }}
                </th>
                <th>
                  {{ 'Assets_Table.SiteName' | translate }}
                </th>
                <th pSortableColumn="description">
                  {{ 'Assets_Table.Description' | translate }}
                  <p-sortIcon field="description" />
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              @let asset = getRowData(rowData);
              <tr class="cursor-pointer" (click)="redirectToAssetDetails(asset.assetId)">
                <td>
                  <a>{{ asset.assetId }}</a>
                </td>
                <td>{{ asset.assetCategoryName }}</td>
                <td>{{ asset.assetTypeName }}</td>
                <td>{{ asset.assetModelName }}</td>
                <td>{{ asset.siteCode }}</td>
                <td>{{ asset.siteName }}</td>
                <td>{{ asset.description }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7">
                  {{ 'Items_Not_Found' | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 25, 50]"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
